import React from "react";
import BraftEditor, { EditorState } from "braft-editor";

import "../../assets/stylus/editor.css";
// import axios from 'axios';
// import moment from 'moment'
// import {cookieManager} from "../../../utils/cookieStorage";

class RichEditor extends React.Component {
  static getDerivedStateFromProps(nextProps) {
    // Should be a controlled component.
    if ("value" in nextProps) {
      return {
        value: nextProps.value || {},
      };
    }
    return null;
  }

  constructor(props) {
    super(props);
    const value = props.initialValue || {};
    // 将HTML字符串转换为编辑器所需要的EditorState实例
    const editorState = EditorState.createFrom(value);
    this.state = {
      editorState,
    };
  }

  resetValue = () => {
    const editorState = EditorState.createFrom(<p></p>);
    this.handleEditorChange(editorState);
  };

  handleEditorChange = (editorState) => {
    this.setState({
      editorState,
    });
    this.triggerChange(editorState.toHTML());
  };

  triggerChange = (changedValue) => {
    if (changedValue === "<p></p>") {
      changedValue = "";
    }
    // Should provide an event to pass value to Form.
    const onChange = this.props.onChange;
    if (onChange) {
      onChange(changedValue);
    }
  };

  render() {
    return (
      <div
        style={{ border: "1px solid #00000029" }}
        className={this.props.className ? this.props.className : ""}>
        <BraftEditor
          value={this.state.editorState}
          onChange={this.handleEditorChange}
          controls={this.props.controls}
        />
      </div>
    );
  }
}

export default RichEditor;



// WEBPACK FOOTER //
// ./src/AntD/components/display/richEditor.js